<template>
  <div class="misc-wrapper">
    <!-- Brand logo-->
    <b-link class="brand-logo">
      <b-img :src="logoUrl" />
    </b-link>
    <!-- /Brand logo-->

    <div class="misc-inner p-2 p-sm-3">
      <div class="w-100 text-center">
        <h2 class="mb-1">
          {{ $t('page.misc.not-authorized') }} 🔐
        </h2>
        <p class="mb-2">
          {{ $t('page.misc.do-not-have-permission') }}
        </p>
        <b-button
            variant="primary"
            class="mb-1 btn-sm-block"
            :to="loginRoute()"
        >{{ $t('page.misc.back-to-home') }}</b-button>
        <b-img
            fluid
            :src="imgUrl"
            alt="Not authorized page"
        />
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable global-require */
import { BLink, BImg, BButton } from 'bootstrap-vue'
import DarkLogo from '@core/layouts/components/Logo.vue'
import LightLogo from '@core/layouts/components/LogoLight.vue'
import store from '@/store/index'
import { getHomeRouteForLoggedInUser } from '@/auth/utils'
import storageHelper from '@/libs/storage'

export default {
  components: {
    BLink,
    BImg,
    BButton,
    DarkLogo,
    LightLogo,
  },
  data() {
    return {
      downImg: require('@/assets/images/pages/not-authorized.svg'),
      logoImg: require('@/assets/images/logo/logo-light.svg'),
      skin: this.$store.state.appConfig.layout.skin,
    }
  },
  computed: {
    logoUrl() {
      if (store.state.appConfig.layout.skin === 'dark') {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.logoImg = require('@/assets/images/logo/logo-dark.svg')
        return this.logoImg
      }
      return this.logoImg
    },
    imgUrl() {
      if (store.state.appConfig.layout.skin === 'dark') {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.downImg = require('@/assets/images/pages/not-authorized-dark.svg')
        return this.downImg
      }
      return this.downImg
    },
  },
  methods: {
    loginRoute() {
      const user = JSON.parse(storageHelper.get('userData'))
      return getHomeRouteForLoggedInUser(user ? user.role : null)
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-misc.scss';
</style>
